import { render, staticRenderFns } from "./Crimereportanalytics.vue?vue&type=template&id=19e22c5f&scoped=true"
import script from "./Crimereportanalytics.vue?vue&type=script&lang=js"
export * from "./Crimereportanalytics.vue?vue&type=script&lang=js"
import style0 from "./Crimereportanalytics.vue?vue&type=style&index=0&id=19e22c5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e22c5f",
  null
  
)

export default component.exports